import React, { useState, useEffect } from 'react';
import {useHistory, useParams} from 'react-router-dom';
import GuestBar from "../../components/GuestInfo/GuestBar";
import {
  Breadcrumbs,
  Typography,
} from "@mui/material";
import {getPreviousStep, getStepFromUrl, requestApi} from "../../utils/utils";
import { makeStyles } from "@mui/styles";
import ActivityCardView from "../../components/Booking/DayTripBooking/ActivityCardView";
import {useDispatch, useSelector} from "react-redux";
import {getActivityList} from "../../redux/actions/activitiesActions";
import {setStep} from "../../redux/actions/stepActions";

const useStyles = makeStyles((theme) => ({
  sectionTitle: {
    fontSize: '1.6rem',
    fontWeight: '600',
    marginBottom: '10px',
  },
  formSection: {
    marginBottom: '20px',
  },
}));

const DayTripBookingPage = ({history}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { activityId } = useParams(); // <- get activityId from the URL
  const activities = useSelector(state => state.activities);
  const {extra:selectedExtras} = useSelector(state => state.transactions);
  const step = useSelector(state => state.step);
  const prevStep = getPreviousStep(step);
  const prefixUrl = 'booking/day-trips';
  const historyUrl = useHistory();

  useEffect(() => {

    dispatch(getActivityList())
  }, []);
  useEffect(() => {
    const stepNum = getStepFromUrl(history.location.pathname);
    dispatch(setStep(stepNum));
  }, []);

  const goBack = () => {
    historyUrl.push(`/${prefixUrl}${prevStep.url}`);
  };

  // Look for the corresponding Activity
  const selectedActivity = Object.values(activities.extra).find(
      (activity) => String(activity.id) === activityId
  );

  return (
      <>
        <GuestBar>
          <Breadcrumbs aria-label="breadcrumb" separator={'>'}>
            <Typography color="text.primary">Day Trip Bookings</Typography>
          </Breadcrumbs>
        </GuestBar>

        {selectedActivity && (
            <ActivityCardView
                key={selectedActivity.id}
                activity={selectedActivity}
                addOrRemove={0}
                pickDate={1}
                history={history}
            />
        )}
      </>
  );
};

export default DayTripBookingPage;
